import React, { useEffect, useState, useRef } from "react";
import './_EncuestaCalidad.scss';

import { ENTITY_URL } from '../../config/config';
import { connection } from '../../utils/connection';

import Spinner from 'react-bootstrap/Spinner';
import FormEncuesta from "../../components/Forms/FormEncuesta";
import { useAuth } from "../../hooks/auth";
import { useParams } from "react-router-dom";
import { BsCheckCircleFill, BsExclamationCircleFill } from 'react-icons/bs';

function EncuestaCalidad() {
    const [encuestaCalidad, setEncuestaCalidad] = useState();
    const [encuestaSeleccionada, setEncuestaSeleccionada] = useState(0);
    const [loading, setLoading] = useState(true);
    const [arrRespuestas, setArrRespuestas] = useState([]);
    const [errorCodigo, setErrorCodigo] = useState(null);
    const formulario = useRef();
    const { token: TOKEN } = useAuth();
    const [persona_id, setPersonaID] = useState();
    const [encuesta_id, setEncuestaID] = useState();

    const { turnoID, hash } = useParams();
    const [selected, setSelected] = useState(false);

    const totalPreguntas = encuestaCalidad?.campos?.length ?? 0;

    const pasarEncuesta = (numero) => {
        const encuestaActual = (encuestaSeleccionada + numero) >= 0 ? encuestaSeleccionada + numero : 0;
        if (encuestaActual === totalPreguntas) {
            enviarRespuesta(arrRespuestas, persona_id, hash, TOKEN);
            setEncuestaSeleccionada(encuestaActual);
        } else {
            setEncuestaSeleccionada(encuestaActual);
        }
    };

    const enviarRespuesta = (respuesta, personaID, hash, token) => {
        const data = {
            respuestas: JSON.stringify(respuesta),
            persona_id: personaID,
            encuesta_id: encuesta_id,
            hash
        };
        connection({ method: 'PUT', url: `${ENTITY_URL.ENCUESTA.CONFIRM}/${encuesta_id}`, extraHeaders: { token: token }, params: data });
    };

    useEffect(() => {
        let data = {
            persona_id: persona_id,
            turnoID: turnoID,
            hash: hash
        };
        connection({ method: 'POST', url: `${ENTITY_URL.ENCUESTA.GETFORM}`, extraHeaders: { token: TOKEN }, params: data }).then(response => {
            if (response.codigo) {
                setErrorCodigo(response.codigo);
            } else if (response.estado > 0 && response.resultados.length > 0) {
                setPersonaID(response.persona_id);
                setEncuestaID(response.encuesta_id);
                setEncuestaCalidad(response.resultados[0]);
            }
            setLoading(false);
        });
    }, [TOKEN, persona_id, hash, turnoID]);

    const cambiarPregunta = () => {
        if (!selected) {
            alert('Selecciona una opcion');
        } else {
            pasarEncuesta(1);
            setSelected(false);
        }
    };

    const volverPregunta = () => {
        pasarEncuesta(-1);
        setSelected(false);
    };

    const progreso = totalPreguntas > 0 ? Math.round((encuestaSeleccionada / totalPreguntas) * 100) : 0;

    return (
        <main className="container container__EncuestaCalidad">

            {loading && (
                <Spinner animation="border" role="status">
                    <span className="visually-hidden">Cargando...</span>
                </Spinner>
            )}

            {!loading && errorCodigo === 'ALREADY_ANSWERED' && (
                <div className="encuesta__estado encuesta__estado--success">
                    <div className="estado__icon">
                        <BsCheckCircleFill size={64} />
                    </div>
                    <h3>¡Muchas gracias!</h3>
                    <p>Tu opinión ya fue registrada.</p>
                </div>
            )}

            {!loading && errorCodigo === 'NOT_FOUND' && (
                <div className="encuesta__estado encuesta__estado--error">
                    <div className="estado__icon">
                        <BsExclamationCircleFill size={64} />
                    </div>
                    <h3>Link inválido</h3>
                    <p>El link de la encuesta no es válido o ya expiró.</p>
                </div>
            )}

            {!loading && !errorCodigo && encuestaCalidad && (
                <div ref={formulario} className="encuesta__card">
                    <div className="encuesta__header">
                        <h2>{encuestaCalidad.form_nombre}</h2>
                        {encuestaCalidad.form_descripcion && (
                            <p>{encuestaCalidad.form_descripcion}</p>
                        )}
                    </div>

                    {encuestaSeleccionada < totalPreguntas ? (
                        <>
                            <div className="encuesta__progress">
                                <div className="progress-label">
                                    <span>Pregunta {encuestaSeleccionada + 1} de {totalPreguntas}</span>
                                    <span>{progreso}%</span>
                                </div>
                                <div className="progress">
                                    <div
                                        className="progress-bar"
                                        role="progressbar"
                                        style={{ width: `${progreso}%` }}
                                        aria-valuenow={progreso}
                                        aria-valuemin="0"
                                        aria-valuemax="100"
                                    />
                                </div>
                            </div>

                            <div className="encuesta__question">
                                <FormEncuesta
                                    preguntas={encuestaCalidad.campos[encuestaSeleccionada]}
                                    state={arrRespuestas}
                                    onClickChange={setArrRespuestas}
                                    setSelected={setSelected}
                                />
                            </div>

                            <div className="encuesta__actions">
                                {encuestaSeleccionada > 0 && (
                                    <button className="btn-greengg" onClick={volverPregunta}>
                                        Anterior
                                    </button>
                                )}
                                <button
                                    className={`btn-orange ${!selected ? 'disabled' : ''}`}
                                    disabled={!selected}
                                    onClick={cambiarPregunta}
                                >
                                    {encuestaSeleccionada === totalPreguntas - 1 ? 'Finalizar' : 'Siguiente'}
                                </button>
                            </div>
                        </>
                    ) : (
                        <div className="encuesta__enviada">
                            <div className="estado__icon">
                                <BsCheckCircleFill size={64} />
                            </div>
                            <h3>¡Gracias por tu respuesta!</h3>
                            <p>Tu opinión ha sido enviada correctamente.</p>
                        </div>
                    )}
                </div>
            )}
        </main>
    );
}

export default EncuestaCalidad;
